<template>
<div class="card">
  <div class="card-body help-card-body">
    <div class="text-center">
      <h4>Certifications & Awards</h4>
    </div>
    <hr>
    <p><b>Don't overdo this section</b>, stick to those things that have some resonably significant bearing on your qualifications for the position sought.</p>
    <p>This section can also list patents held, publications written, speeches and lectures presented, and special recognitions.</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'certs',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
